import { Provider } from 'react-redux';
import { HashRouter } from 'react-router';

import { main } from './configuration';

import AppContainer from './features/app/App.container';
import { ErrorBoundary } from './features/app/ErrorBoundary';
import { createRoot } from 'react-dom/client';
import { store } from './configuration/setup/store';
import { config } from './config';
import { handleSilentSigninRedirectInIframe, isRunningInIframe } from '../src-login-lib';
import { IntlProvider } from 'react-intl';
import { DEFAULT_LOCALE } from './configuration/lang/lang';
import { useDisplayMessages, useLocale } from './configuration/lang/langSlice';

const App = () => {
    const userLocale = useLocale();
    const displayMessages = useDisplayMessages();

    return (
        <IntlProvider
            defaultLocale={DEFAULT_LOCALE}
            key={userLocale}
            locale={userLocale ?? 'en-GB'}
            messages={displayMessages}
        >
            <ErrorBoundary>
                <HashRouter>
                    <AppContainer />
                </HashRouter>
            </ErrorBoundary>
        </IntlProvider>
    );
};

const renderApplication = () => {
    const container = document.getElementById('root') as HTMLElement;
    const root = createRoot(container);

    root.render(
        <Provider store={store}>
            <App />
        </Provider>
    );
};

const isDev = import.meta.env.DEV;
const isProd = import.meta.env.PROD;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;

if (isDev || isProdPreview) {
    // import('../mocks/browser').then(({ startWorker }) => startWorker()).then(() => main(renderApplication));
    void main(renderApplication);
}

const isRedirect = window.location.href.startsWith(config.login.redirectUri as string);
const runsInIframe = isRunningInIframe();

if (isRedirect && runsInIframe) {
    void handleSilentSigninRedirectInIframe({
        redirectUri: `${config.login.redirectUri}`,
        authority: `${config.login.authority}`,
        clientId: `${config.login.clientId}`,
    });
} else if (isProd && !isProdPreview) {
    void main(renderApplication);
}
